module.exports = __webpack_public_path__ + "img/garbage_access.01408a46.png";